import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import React, { useMemo } from "react";

import Helpers from "../../../commons/helpers";
import useStrings from "../../../hooks/useStrings";
import Box from "../../Box";
import DataTableHeadCell from "../../DataTable/DataTableHeadCell";
import Typography from "../../Typography";

import { IResource, RoleResourcePermission } from "../../../commons/interfaces";
import { Permission, RoleTableMode } from "../../../constants/enums";
import usePermissionTable from "../../../hooks/usePermissionTable";
import CheckBox from "../../CheckBox";

interface IProps {
    disabled: boolean;
    tableMode?: RoleTableMode;
    resources: IResource[];
    roleResourcePermissions: RoleResourcePermission[];
    onChangePermission: (resource: RoleResourcePermission[]) => void;
}

export const RolePermissionTable: React.FC<IProps> = ({
    disabled,
    tableMode = "normal",
    resources,
    roleResourcePermissions = [],
    onChangePermission,
}: IProps) => {
    const Strings = useStrings();
    const language = Strings.getLanguage();

    const { permissionList, advancePermissions, fullPermission, checkAll, onChangeValue, onCheckAll } = usePermissionTable<RoleResourcePermission>({
        data: roleResourcePermissions,
        onChangePermission,
        tableMode,
    });

    const filteredPermissionList = useMemo(() => {
        if (tableMode === "advance") return permissionList;
        return permissionList.filter((el) => !advancePermissions.includes(el.code as Permission));
    }, [tableMode, permissionList]);

    return (
        <Box
            sx={{
                overflow: "auto",
                borderTopLeftRadius: "0.75rem",
                borderTopRightRadius: "0.75rem",
                width: {
                    xs: "90vw",
                    sm: "95vw",
                    md: "100%",
                    lg: "100%",
                },
            }}
        >
            <Table>
                <Box component="thead">
                    <TableRow>
                        <DataTableHeadCell sorted={false} width={60}>
                            {Strings.Common.SEQUENCE}
                        </DataTableHeadCell>

                        <DataTableHeadCell sorted={false} width={220}>
                            {Strings.Role.RESOURCE}
                        </DataTableHeadCell>
                        {filteredPermissionList.map((permission) => (
                            <DataTableHeadCell align="center" sorted={false} key={permission.code}>
                                {permission.name}
                            </DataTableHeadCell>
                        ))}
                        <DataTableHeadCell align="right" sorted={false}>
                            <CheckBox
                                onChange={onCheckAll}
                                disabled={disabled}
                                checked={checkAll}
                                // color={checkedAll || listResource.length === listModule.length * 6 ? "dark" : undefined}
                            />
                            {/* <Switch
                                onChange={handleAll}
                                disabled={disabled}
                                checked={checkedAll || listResource.length === listModule.length * 6}
                                checkedColor={checkedAll || listResource.length === listModule.length * 6 ? "dark" : undefined}
                            /> */}
                        </DataTableHeadCell>
                    </TableRow>
                </Box>
                <TableBody>
                    {roleResourcePermissions.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={8} sx={{ borderBottom: "unset" }}>
                                <Box textAlign="center">
                                    <Typography variant="button" color="dark" fontWeight="regular">
                                        {Strings.Common.NO_DATA}
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                    {roleResourcePermissions.length > 0 &&
                        roleResourcePermissions.map((roleResource, index) => {
                            const name = resources.find((el) => el.resourceCode === roleResource.resourceCode)?.resourceName;
                            return (
                                <TableRow key={roleResource.id}>
                                    <TableCell width={60}>
                                        <Typography variant="caption" fontWeight="bold">
                                            {index + 1}
                                        </Typography>
                                    </TableCell>
                                    <TableCell width={220}>
                                        <Typography variant="caption" fontWeight="bold">
                                            {Helpers.getDefaultValueMultiLanguage(name, language)}
                                        </Typography>
                                    </TableCell>
                                    {filteredPermissionList.map((permission) => {
                                        const getDisabledValue = () => {
                                            if (disabled === true) return true;

                                            const permissionValue = Number(permission?.code);
                                            if (!Helpers.isNullOrEmpty(roleResource?.enablePermission))
                                                return (roleResource?.enablePermission & permissionValue) !== permissionValue;

                                            return false;
                                        };

                                        return (
                                            <TableCell align="center" key={permission.code}>
                                                <CheckBox
                                                    onChange={onChangeValue(permission.code as Permission, index)}
                                                    disabled={getDisabledValue()}
                                                    checked={(roleResource.permission & Number(permission.code)) == permission.code}
                                                    // color={checkedAll || listResource.length === listModule.length * 6 ? "dark" : undefined}
                                                />
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell align="right">
                                        {Helpers.isNullOrEmpty(roleResource?.enablePermission) && (
                                            <CheckBox
                                                onChange={onChangeValue(fullPermission, index)}
                                                disabled={disabled}
                                                checked={roleResource.permission === fullPermission}
                                                // color={checkedAll || listResource.length === listModule.length * 6 ? "dark" : undefined}
                                            />
                                        )}
                                        {!Helpers.isNullOrEmpty(roleResource?.enablePermission) && (
                                            <CheckBox
                                                onChange={onChangeValue(
                                                    // roleResource.permission === roleResource?.enablePermission ? 0 : roleResource?.enablePermission,
                                                    roleResource?.enablePermission,
                                                    index
                                                )}
                                                disabled={disabled}
                                                checked={roleResource.permission === roleResource?.enablePermission}
                                                // color={checkedAll || listResource.length === listModule.length * 6 ? "dark" : undefined}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </Box>
    );
};

export default RolePermissionTable;
